import axios from "axios";
import store from "../store";

export const serverUrl = `http://localhost:3000/v1/`;
export const prodUrl = `https://backend.salusion.com/v1/`;
const OVERRIDE_SERVER = process.env.REACT_APP_OVERRIDE_SERVER;
// OVERRIDE_SERVER should exist globally if used

const HOSTS = {
  "my.salusion.com": "https://backend.salusion.com/v1/",
  "my.salusion-staging.com": `https://backend.salusion-staging.com/v1/`,
  "my.salusion-preprod.com": `https://backend.salusion-preprod.com/v1/`,
  "my.salusion-production.com": `https://backend.salusion-production.com/v1/`,
};

const getIntHost = ({ hostname }) => {
  for (let i = 0; i < hostname.length; i++) {
    if (!isNaN(hostname[i])) {
      return `https://b${hostname[i]}.salusion.com/v1/`;
    }
  }
  return "";
};

const hostname = window.location.hostname;
let HOST = HOSTS[hostname];

// if (process.env.CODESPACE_ACCOUNT?.toUpperCase() === "TRUE") {
//   HOST = HOSTS["my.salusion-staging.com"];
// }

export const salusionURL =
  HOST || OVERRIDE_SERVER || "https://backend.salusion.com/v1/";

axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    // 500 errors redirect to error
    if (error?.response?.data?.code !== "101-02") return null;
    else store.invalidateUser({});
    if (!error.response && store?.user?.isSeanOrCustomer) {
      window.location.href = "/error";
    }
    return Promise.reject(error);
  }
);

export const axiosWrapper = async (
  method,
  target,
  payload = null,
  content = null,
  token,
  progressFunc,
  options
) => {
  const url = !Boolean(options?.disablePrefix)
    ? salusionURL + target
    : target;

  if (content) {
    const formData = new FormData();
    await formData.append("upload", content);

    return axios.post(url, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });
  } else {
    const config = {
      url,
      method,
      headers: { Authorization: `Bearer ${token}` },
      data: payload || null,
      onDownloadProgress: progressFunc
        ? ({ total, loaded }) => progressFunc({ total, loaded })
        : null,
    };

    if (options?.responseType) config.responseType = options.responseType;

    return axios(config);
  }
};
